import React, { useState } from 'react';

import useMailingAddressData from '../../../hooks/useMailingAddressData';
import useMailingActions from '../../../hooks/useMailingActions';
import useSpinner from '../../../hooks/useSpinner';
import Form from '../MainForm';
import InputRadio from '../InputRadio';
import { Row } from '../../Structure';
import { CompanyAddressForm } from './index';
import { ApplicantContent } from '../../Content/AddressScreen';

const MailingAddressForm = () => {
  const [values, setValues] = useState(useMailingAddressData());
  const [required, setRequired] = useState(false);
  const { selectMailingAddress, saveMailingAddress } = useMailingActions();
  const [enableSpinner] = useSpinner();

  const { useHomeAddress } = values;
  let formName = useHomeAddress ? 'home' : 'mailing';

  const handleSubmit = (event) => {
    event.preventDefault();
    enableSpinner();
    saveMailingAddress({ ...values });
  };

  const onMailingDataUpdate = (value) => {
    const {
      mailingAddressLine1,
      mailingAddressLine2,
      mailingAddressLine3,
      mailingAddressLine4,
      mailingPostcode,
    } = value;
    setValues({
      ...values,
      mailingAddressLine1,
      mailingAddressLine2,
      mailingAddressLine3,
      mailingAddressLine4,
      mailingPostcode,
    });
  };

  const changeFormAction = (currentFormName) => {
    formName = currentFormName;
    setRequired(!required);
    setValues({ ...values, useHomeAddress: currentFormName === 'home' });
    selectMailingAddress(!useHomeAddress);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="radio-row">
        <InputRadio
          name="useHomeAddress"
          value="home"
          onChange={changeFormAction}
          checked={useHomeAddress}
        >
          Home Address
        </InputRadio>
        <InputRadio
          name="useHomeAddress"
          value="mailing"
          onChange={changeFormAction}
          checked={!useHomeAddress}
        >
          Alternative Card Mailing Address
        </InputRadio>
      </Row>
      <Row className={`address-row ${formName}`}>
        {!useHomeAddress && <ApplicantContent />}
        <CompanyAddressForm
          onMailingDataUpdate={onMailingDataUpdate}
          required={required}
          mailingAddressData={values}
        />
      </Row>
    </Form>
  );
};

export default MailingAddressForm;
